module.exports = __webpack_public_path__ + "img/bg-assignment.822e076d.png";